import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css'; // make sure to include styles
import { styled } from '@mui/material/styles';
import { Filter } from '../../../Svg';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip,
  MenuItem,
  Menu,
  Stack, Button,
  InputBase
} from '@mui/material';
const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));


/* const CalendarComp = () => {
  const [date, setDate] = useState(new Date());
  const handleCatClick = () => {
    // You can define the logic you want to execute when the button is clicked
    console.log('Button clicked!');
    // Example: Toggle a state or handle additional actions
  };
  const handleDateChange = (newDate) => {
    setDate(newDate);
  };

  return (

    <div>
      <Calendar
        onChange={handleDateChange}
        value={date}
      />
    </div>
  );
};

export default CalendarComp; */
